/* lua.js generated code 0.3.0 */
require("clover/panel/RevisitPanel")
//var BottomButtonAnim = require("clover/panel/component/common/uiButtonAnims/HomeSceneBottomBtnAnim")
var RevisitButton = xClass("RevisitButton", HomeSceneButton)

RevisitButton.prototype.ctor = function (recTime, rewards) {
    console.log("[tt] RevisitButton rewards", recTime, rewards)
    let self = this
    self.rewards = rewards
    self.recTime = recTime
    let title = ""
    self.dcSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    self.dcType = ""
    if (recTime == 0 && rewards && rewards[1]){
        title = "限时福利"
        self.dcType = "limit_reward"
    }else{
        title = "温馨提示"
        self.dcType = "reminder"
    }
    HomeSceneButton.prototype.ctor.call(self, title, "tt_sidehint/lobby_icon_wxts.png")
    self.imageNode.setScale(0.8)
    self.bg.setOpacity(255 * 0.7)
    self.updateUI()
    DCAssist.dc4DouyinSidebar("icon_show", self.dcSession, self.dcType)
}
RevisitButton.prototype.customInit = function () {
}

RevisitButton.prototype.onCick =  function () {
    let self = this
    self.dcSession = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    DCAssist.dc4DouyinSidebar("icon_click", self.dcSession, self.dcType)
    let onFetchCb = function(){
        self.rewards = {}
        self.dcType = "reminder"
        self.text.setString("温馨提示")
    }
    RevisitPanel.show(self.recTime, self.rewards, self.dcSession, onFetchCb)
}

RevisitButton.prototype.updateUI = function () {
    
}
module.exports = RevisitButton
